
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { useFetchData } from "../../../../hooks/useFtechData";
import { JOBSEEKER_URL } from "../../../../resources/resource";
import GuarantorButton from "../../GuarantorButton";
import EducationList from "../../Education";
import WorkExperienceList from "../../Work";
import ContactList from "../../ContactPerson";
import Certificate from "../../Certificate";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
const MyDetails = () => {
     const dispatch = useDispatch();
     const navigate = useNavigate()
      const { currentUser, token } = useSelector((state) => state.user);
      const loggedInUser = useSelector((state) => state.user);
      
      const { data: userDetails, refetch: refetchUser } = useFetchData(
        JOBSEEKER_URL + `/getAjobSeeker/${loggedInUser?.currentUser?._id}`
      );
      const userId = localStorage.getItem('userId');
      
            const handleCv =() => {
                  if (loggedInUser?.currentUser === null) {
            toast.error("Kindly login to continue");
            navigate("/signin");
            return;
          }
          if (loggedInUser?.currentUser?.userType !== "jobSeeker") {
            toast.info("Only for jobSeekers");
            return;
          }
          navigate(`/${loggedInUser?.currentUser?._id}/createCV`);
            }
  return (
    <div>
    <GuarantorButton />
    
            {/* ---- Education ---- */}
            <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
              <EducationList
                refetch={refetchUser}
                userEducation={userDetails?.education}
              />
            </div>
    
            <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
              <WorkExperienceList
                userExperience={userDetails?.workExperience}
                refetch={refetchUser}
              />
            </div>
    
            {/* ---- Guarantor ---- */}
            <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
              <ContactList
                userGuarantors={userDetails?.guarantors}
                refetch={refetchUser}
              />
            </div>
    
            <div className="bg-white rounded-lg shadow-sm p-6 mb-8">
              <Certificate
                userCertificate={userDetails?.certificates}
                refetch={refetchUser}
              />
            </div>
              <button
            onClick={handleCv}
            className="bg-orange-500 px-6 py-2 ml-80 rounded-full text-white hover:bg-orange-600 transition-colors"
          >
            Create a free CV
          </button>

       
      
    </div>
  )
}

export default MyDetails
